import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Vault" */ './lazyIndex'));

export let VaultPanel = createLazyComponent(lazyModule, m => m.VaultPanel);
export let addUserDataItemToVaultLazy = new LazyAction(lazyModule, m => m.addUserDataItemToVault);
export let initializeVaultInfoLazy = new LazyAction(lazyModule, m => m.initializeVaultInfo);
